<ng-container *ngIf="launch$ | async as launch">
  <ng-container *ngIf="launch.isLive && type == 'table'"><blinker></blinker></ng-container>
  <ng-container *ngIf="launch.isLive && type == 'page'"><blinker paddingRight="0"></blinker></ng-container>
  <ng-container *ngIf="shouldShowCountdown(launch)">
    <launch-countdown [missionId]="launch.link" [justify]="isMobile ? justifyMobile : justify"></launch-countdown>
  </ng-container>
  <ng-container *ngIf="shouldShowOverrideText(launch)">{{launch.override.text}}</ng-container>
  <ng-container *ngIf="shouldShowDate(launch)">{{dateText(launch)}}</ng-container>
  <ng-container *ngIf="shouldShowWindow(launch)">{{windowText(launch)}}</ng-container>
  <ng-container *ngIf="shouldShowTbd(launch)">TBD</ng-container>
  <ng-container *ngIf="launch.isLive && type == 'widget'">
    <blinker display="block" paddingRight="0" marginTop=10></blinker>
  </ng-container>
</ng-container>